import 'imarc-boilerplate/js/dropdown.plugin';

export default $(()=>{
    let $navPrimary = $('nav.primary');
    $navPrimary.dropdown();
    let $video = $('.remodal video, .remodal iframe');
    let $navigationVideo = $('.navigation-video .video');

    $(document).on('opened', '.remodal', () =>{
        $navigationVideo.html($video);
    });

    $(document).on('closed', '.remodal', ()=>{

        $navigationVideo.html('');
    });

});